<template lang="pug">
  ods-row.b2b-table-select-rows
    ods-col(:span='10')
      .b2b-table-select-rows__info
        | {{ $t('msg_generics.table_select_rows', { num: total }) }}
    ods-col(:span='12')
      .b2b-table-select-rows__actions
        slot(name='actions')
</template>

<script>
export default {
  name: 'b2b-table-select-rows',

  props: ['totalSelect'],

  computed: {
    total () {
      return this.totalSelect
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-table-select-rows {
  height: 5rem;
  padding: 1rem 1rem 1rem 2rem;
  background: var(--color-bg-hover-2);
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 1;
  box-shadow: 0 0 1rem .5rem rgba(0, 0, 0, .05);
  .b2b-table-select-rows__info {
    color: var(--color-bg-interactive);
    padding-top: 1rem;
  }
  ::v-deep .b2b-table-select-rows__actions {
    position: relative;
    right: 3rem;
    color: var(--color-bg-interactive);
  }
}
</style>
